import React from 'react';
import BentoCard from '../layout/BentoCard';
import StatusIndicator from '../ui/StatusIndicator';
import GradientText from '../ui/GradientText';
import Button from '../ui/Button';
import { profile } from '../../data/profile';
import { metrics } from '../../data/metrics';

/**
 * HeroSection - Main hero/header section
 * Features name, role, tagline, CTAs, and quick metrics
 */
const HeroSection = () => {
  // Split name for gradient effect on last name
  const firstName = profile.name.split(' ')[0];
  const lastName = profile.name.split(' ').slice(1).join(' ');

  return (
    <header className="mb-6 md:mb-8 lg:mb-12">
      <BentoCard span="full" hover={false} delay={0}>
        <div className="p-8 md:p-12 lg:p-16">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">

            {/* Left: Main Info */}
            <div className="space-y-6">
              <div className="space-y-2">
                <StatusIndicator status={profile.availability} type="success" />

                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
                  {firstName}{' '}
                  <GradientText>{lastName}</GradientText>
                </h1>

                <p
                  className="text-xl md:text-2xl font-light"
                  style={{ color: 'var(--color-text-muted)' }}
                >
                  {profile.role}
                </p>
              </div>

              <p
                className="text-lg max-w-xl"
                style={{ color: 'var(--color-text-muted)' }}
              >
                {profile.tagline}
              </p>

              {/* CTAs */}
              <div className="flex flex-wrap gap-3">
                <Button
                  variant="primary"
                  size="md"
                  onClick={() => window.location.href = `mailto:${profile.email}`}
                >
                  Let's Talk →
                </Button>
                <Button
                  variant="secondary"
                  size="md"
                  href={profile.linkedin}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(profile.linkedin, '_blank', 'noopener,noreferrer');
                  }}
                >
                  View LinkedIn
                </Button>
              </div>
            </div>

            {/* Right: Quick Stats */}
            <div className="grid grid-cols-2 gap-4">
              {metrics.map((metric) => (
                <div
                  key={metric.id}
                  className="p-4 rounded-xl border transition-colors duration-300 hover:border-[var(--color-accent)]/30"
                  style={{
                    background: 'rgba(255,255,255,0.02)',
                    borderColor: 'var(--color-border)'
                  }}
                >
                  <div className="text-2xl mb-1">{metric.icon}</div>
                  <div
                    className="text-2xl font-bold font-mono"
                    style={{ color: metric.color }}
                  >
                    {metric.value}
                  </div>
                  <div
                    className="text-sm"
                    style={{ color: 'var(--color-text-muted)' }}
                  >
                    {metric.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </BentoCard>
    </header>
  );
};

export default HeroSection;
